import React from "react";

export default function Reviews() {
  return (
    <section
      id="reviews"
      style={{
        background: "linear-gradient(to right, #154b8d, #2e76c4)",
        color: "white",
        textAlign: "center",
        padding: "70px 20px",
      }}
    >
      {/* ✅ Hover animation for the white review cards ONLY */}
      <style>{`
        #reviews .review-card {
          transition: transform .22s ease, box-shadow .22s ease;
          will-change: transform, box-shadow;
        }
        #reviews .review-card:hover {
          transform: translateY(-6px);
          box-shadow: 0 14px 28px rgba(0,0,0,.16);
        }
        @media (prefers-reduced-motion: reduce) {
          #reviews .review-card { transition: none; }
          #reviews .review-card:hover { transform: none; box-shadow: 0 8px 24px rgba(0,0,0,.08); }
        }
      `}</style>

      <div className="container">
        <h2
          style={{
            fontSize: "30px",
            fontWeight: 800,
            marginBottom: "24px",
            letterSpacing: "0.5px",
            textTransform: "uppercase",
          }}
        >
          What Clients Say
        </h2>

        <p
          style={{
            fontSize: "16px",
            opacity: 0.95,
            marginBottom: "36px",
            lineHeight: 1.6,
          }}
        >
          See why small business owners and incorporated professionals across
          Canada trust <strong>FA Solutions</strong> for corporate tax and
          bookkeeping.
        </p>

        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
            gap: "24px",
            maxWidth: "1000px",
            margin: "0 auto",
          }}
        >
          {/* Review 1 */}
          <div
            className="review-card"
            style={{
              background: "rgba(255,255,255,0.97)",
              color: "#17569b",
              padding: "24px",
              borderRadius: "10px",
              flex: "1 1 300px",
              boxShadow: "0 8px 24px rgba(0,0,0,0.08)",
              border: "1px solid rgba(23,86,155,0.1)",
            }}
          >
            <p
              style={{
                fontStyle: "italic",
                marginBottom: "12px",
                lineHeight: 1.6,
              }}
            >
              “Great service, I was struggling so much with bookkeeping and gathering receipts and this business gave me a peace of mind. They reconciled everything and completed the financial statements and prepared by T2 return for my corporation by the filing deadline and saved us from late filing penalties. Very professional and the accountant was very knowledgeable and detailed at explaining. Highly recommend!”
            </p>
            <strong>— Thomas H.</strong>
          </div>

          {/* Review 2 */}
          <div
            className="review-card"
            style={{
              background: "rgba(255,255,255,0.97)",
              color: "#17569b",
              padding: "24px",
              borderRadius: "10px",
              flex: "1 1 300px",
              boxShadow: "0 8px 24px rgba(0,0,0,0.08)",
              border: "1px solid rgba(23,86,155,0.1)",
            }}
          >
            <p
              style={{
                fontStyle: "italic",
                marginBottom: "12px",
                lineHeight: 1.6,
              }}
            >
              “Professional, on-time, and great at explaining tax deductions. They prepared our corporation's financial statements and gave amazing and fast bookkeeping services. They were organized and extremely very helpful in gathering our business expenses and knowing what to claim to have us reduce our taxes owing. It would have taken us forever to do the bookkeepinh alone.  I recommend them to any corporation who needs help with bookkeeping and T2 preparation”
            </p>
            <strong>— Ryan W.</strong>
          </div>

          {/* Review 3 */}
          <div
            className="review-card"
            style={{
              background: "rgba(255,255,255,0.97)",
              color: "#17569b",
              padding: "24px",
              borderRadius: "10px",
              flex: "1 1 300px",
              boxShadow: "0 8px 24px rgba(0,0,0,0.08)",
              border: "1px solid rgba(23,86,155,0.1)",
            }}
          >
            <p
              style={{
                fontStyle: "italic",
                marginBottom: "12px",
                lineHeight: 1.6,
              }}
            >
              “Excellent tax service.”
            </p>
            <strong>— Brandon A.</strong>
          </div>
        </div>

        <div style={{ marginTop: "40px" }}>
          <a
            href="https://g.page/r/CSf8Mu9eJRU7EBM/review"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: "10px",
              color: "white",
              textDecoration: "none",
              fontWeight: 600,
              fontSize: "16px",
            }}
          >
            <img
              src={process.env.PUBLIC_URL + "/Google.png"}
              alt="Google logo"
              style={{
                width: "24px",
                height: "24px",
                filter: "drop-shadow(0 1px 1px rgba(0,0,0,0.2))",
              }}
              loading="lazy"
            />
            <span style={{ textDecoration: "underline" }}>
              Read our Google Reviews
            </span>
          </a>
        </div>
      </div>

      {/* wave separator (unchanged) */}
      <div style={{ marginTop: "-1px" }}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 1440 320"
          style={{ display: "block", width: "100%", height: "80px" }}
        >
          <path
            fill="#1f6bc4"
            fillOpacity="1"
            d="M0,192L120,165.3C240,139,480,85,720,80C960,75,1200,117,1320,138.7L1440,160L1440,320L1320,320C1200,320,960,320,720,320C480,320,240,320,120,320L0,320Z"
          ></path>
        </svg>
      </div>
    </section>
  );
}
